<template>
    <div class="warp">
        <div class="echarts" ref="echarts"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'echartsLine',
    props: ['echartsLineData'],
    data() {
        return {
            newCustomerLineChartYdata: [5, 7, 8, 10, 15, 19, 17, 18, 14, 12, 6, 5],
            activeUsersYdata: [3, 5, 6, 9, 12, 16, 15, 11, 8, 5, 3, 1],
            cumulativeUsersYdata: [2, 4, 5, 8, 11, 15, 14, 10, 7, 4, 4, 2],
            orderPayCustomerYdata: [13, 15, 16, 19, 22, 26, 25, 21, 18, 15, 13, 11],
            cumulativepayUsersYdata: [11, 13, 14, 17, 24, 28, 29, 23, 20, 19, 17, 15],
            xdisplaydata: []
        }
    },
    watch: {
        echartsLineData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.initChart(this.echartsLineData)
            })
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    mounted() {},
    methods: {
        initChart(Edata) {
            this.xdisplaydata = Edata.xdisplaydata
            this.newCustomerLineChartYdata = Edata.newCustomerLineChartYdata
            this.activeUsersYdata = Edata.activeUsersYdata
            this.cumulativeUsersYdata = Edata.cumulativeUsersYdata
            this.orderPayCustomerYdata = Edata.orderPayCustomerYdata
            this.cumulativepayUsersYdata = Edata.cumulativepayUsersYdata
            this.chart = echarts.init(this.$refs.echarts)
            this.chart.setOption(this.getOption())
        },
        getOption: function() {
            return {
                color: ['#409EFF', '#41CCF0', '#67C23A', '#ACDF84', '#F5CC4D'],
                // title: {
                //     subtext: '近期趋势',
                //     left: 'left',
                //     subtextStyle: {
                //         color: '#606266'
                //     }
                // },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['新增用户', '活跃用户', '累计用户', '付费用户', '累计付费用户'],
                    icon: 'circle',
                    itemWidth: 10, // 设置宽度
                    itemHeight: 10 // 设置高度
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    data: this.xdisplaydata
                },
                yAxis: {
                    type: 'value',
                    name: '',
                    // nameTextStyle: {
                    //     color: 'red'
                    // },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#f2f2f2'],
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '新增用户',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.newCustomerLineChartYdata
                    },
                    {
                        name: '活跃用户',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.activeUsersYdata
                    },
                    {
                        name: '累计用户',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.cumulativeUsersYdata
                    },
                    {
                        name: '付费用户',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.orderPayCustomerYdata
                    },
                    {
                        name: '累计付费用户',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.cumulativepayUsersYdata
                    }
                ]
            }
        }
    }
}
</script>
<style scoped>
.warp {
    width: 100%;
    height: 100%;
}
.echarts {
    width: 100%;
    height: 100%;
}
</style>